export { combineContainerMixins, makeCreateContainerFunction, createContainer } from "./create-container";


//////////////////
// WEBPACK FOOTER
// ./node_modules/victory-create-container/es/index.js
// module id = 1509
// module chunks = 0